module.exports = __webpack_public_path__ + "img/chevron-right.f51983c1.svg";